import { z } from 'zod';

export const createCategorySchema = z
  .object({
    name: z
      .string()
      .trim()
      .min(1, 'Category name is required')
      .max(80, 'Category name is too long'),
    seasonality: z.enum(['evergreen', 'seasonal']),
    startDate: z.string().trim().optional(),
    endDate: z.string().trim().optional(),
    parentId: z.string().trim().optional(),
    image: z.instanceof(File).optional(),
  })
  .superRefine((value, ctx) => {
    if (value.seasonality !== 'seasonal') return;
    if (!value.startDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Start date is required for seasonal categories',
        path: ['startDate'],
      });
    }
    if (!value.endDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'End date is required for seasonal categories',
        path: ['endDate'],
      });
    }
  });

export type CreateCategoryInput = z.infer<typeof createCategorySchema>;
